import { useEffect } from 'react';
import { showLoadingIcon, hideLoadingIcon } from "../utils";

function Searching() {

  useEffect(() => {
    showLoadingIcon();
    return () => hideLoadingIcon();
  }, []);

  return (
    null
  );
}

export default Searching;